import { Environment, getConfiguration } from "../../config";
import { ApiClient } from "./ApiClient";

export interface IAuthenticator {
  aquireNewToken(callback?: (token: string) => void): Promise<void>;
  getCurrentToken(): Promise<string | null>;
  getImpersonatedUser(): string | null;
}

export class EnvirotainerApiClient extends ApiClient {
  private readonly authenticator: IAuthenticator;

  constructor(authenticator: IAuthenticator, env?: Environment) {
    const config = getConfiguration(env);

    super({
      baseApiUrl: config.headerAuthWidgetsApiUrl,
      apiVersion: config.headerAuthWidgetsApiVersion,
      basePath: config.baseApiPath,
    });

    this.authenticator = authenticator;
  }

  async appendHeaders(): Promise<HeadersInit> {
    if (!this.authenticator) {
      Promise.reject("Authenticator does not setted");
    }

    const authHeader = await this.getAuthHeader();
    const impersonatedHeader = this.getImpersonatedHeader();

    return Promise.resolve({ ...this.appJsonHeader, ...authHeader, ...impersonatedHeader });
  }

  private async getAuthHeader(): Promise<HeadersInit> {
    const token = await this.authenticator.getCurrentToken();
    if (token !== null && !this.isExpiredJWT(token)) {
      return Promise.resolve({ "auth-jwt": token });
    }

    return new Promise((resolve) => this.authenticator.aquireNewToken((t: string) => resolve({ "auth-jwt": t })));
  }

  private getImpersonatedHeader(): HeadersInit {
    const impersonatedUser: string | null = this.authenticator.getImpersonatedUser();

    if (impersonatedUser !== null) {
      return { impersonatedas: impersonatedUser }
    }

    return {};
  }
}
